import React, { useState } from "react"
import { Button, FormControl, FormGroup, Card } from "react-bootstrap"
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import styled from "styled-components"
import { signInAction } from "../app/actions";

const LoginPageView = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
`

const LoginPage = ({}) => {
    const dispatch = useDispatch()
    const [email, setEmail] = useState()
    const [password, setPassword] = useState()

    const login = () => {
        dispatch(signInAction(email, password))
    }

    const isValid = password && password.length > 0 && email.indexOf("@") > -1 && email.split('@')[1].indexOf(".") > -1;

    return <LoginPageView>
        <Card>
            <Card.Header>
                <Card.Title componentClass="h3">Login</Card.Title>
            </Card.Header>
            <Card.Body>
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                        login();
                    }}
                >
                    <FormGroup>
                        <FormControl
                            value={email}
                            type="email"
                            placeholder="E-mail"    
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormControl
                            value={password}
                            type="password"
                            placeholder="Lösenord"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Button
                            type="submit"
                            disabled={!isValid}
                            bsStyle="success"
                            bsSize="large"
                            block={true}
                        >
                            Login
                        </Button>
                    </FormGroup>
                </form>
            </Card.Body>
        </Card>
    </LoginPageView>
}

export default LoginPage